import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08751f2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "preview_tab",
  class: "my-6"
}
const _hoisted_2 = { class: "tab-wrapper-primary" }
const _hoisted_3 = { class: "tab-heading-primary" }
const _hoisted_4 = { class: "flex flex-col gap-4 p-6" }
const _hoisted_5 = { class: "w-full pt-2" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  class: "label-primary flex gap-1",
  for: "embed-code"
}
const _hoisted_8 = { class: "tab-wrapper-primary mt-6" }
const _hoisted_9 = { class: "tab-heading-primary flex items-center justify-between" }
const _hoisted_10 = { class: "flex items-center rounded-md border border-neutral-25 overflow-hidden" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "3",
    width: "20",
    height: "14",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8",
    y1: "21",
    x2: "16",
    y2: "21"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "21"
  })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "5",
    y: "2",
    width: "14",
    height: "20",
    rx: "2",
    ry: "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  })
], -1))
const _hoisted_13 = {
  key: 0,
  class: "flex flex-col gap-4 p-6"
}
const _hoisted_14 = { class: "relative rounded-lg min-h-[700px]" }
const _hoisted_15 = {
  key: 1,
  class: "flex justify-center p-6 bg-gray-100"
}
const _hoisted_16 = { class: "phone-frame" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"safari-status-bar\" data-v-08751f2b><span class=\"font-semibold\" data-v-08751f2b>9:41</span><div class=\"safari-notch\" data-v-08751f2b></div><div class=\"flex items-center gap-1\" data-v-08751f2b><svg width=\"15\" height=\"11\" viewBox=\"0 0 17 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-08751f2b><rect x=\"0\" y=\"9\" width=\"3\" height=\"3\" rx=\"0.5\" fill=\"white\" data-v-08751f2b></rect><rect x=\"4.5\" y=\"6\" width=\"3\" height=\"6\" rx=\"0.5\" fill=\"white\" data-v-08751f2b></rect><rect x=\"9\" y=\"3\" width=\"3\" height=\"9\" rx=\"0.5\" fill=\"white\" data-v-08751f2b></rect><rect x=\"13.5\" y=\"0\" width=\"3\" height=\"12\" rx=\"0.5\" fill=\"white\" data-v-08751f2b></rect></svg><svg width=\"14\" height=\"11\" viewBox=\"0 0 24 18\" fill=\"white\" xmlns=\"http://www.w3.org/2000/svg\" data-v-08751f2b><path d=\"M12 16.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM12 10c2.9 0 5.5 1.2 7.4 3.1l-2.1 2.1C15.8 13.8 14 13 12 13s-3.8.8-5.3 2.2l-2.1-2.1C6.5 11.2 9.1 10 12 10zm0-6.5c4.3 0 8.2 1.7 11 4.6l-2.1 2.1C18.5 7.8 15.4 6.5 12 6.5S5.5 7.8 3.1 10.2L1 8.1C3.8 5.2 7.7 3.5 12 3.5z\" data-v-08751f2b></path></svg><svg width=\"25\" height=\"11\" viewBox=\"0 0 27 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-08751f2b><rect x=\"0.5\" y=\"0.5\" width=\"22\" height=\"12\" rx=\"2\" stroke=\"white\" stroke-opacity=\"0.35\" data-v-08751f2b></rect><rect x=\"2\" y=\"2\" width=\"19\" height=\"9\" rx=\"1\" fill=\"white\" data-v-08751f2b></rect><path d=\"M24 4.5v4a2 2 0 000-4z\" fill=\"white\" fill-opacity=\"0.4\" data-v-08751f2b></path></svg></div></div><div class=\"safari-address-bar\" data-v-08751f2b><div class=\"safari-url-pill\" data-v-08751f2b><svg width=\"11\" height=\"11\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#8e8e93\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-08751f2b><rect x=\"3\" y=\"11\" width=\"18\" height=\"11\" rx=\"2\" ry=\"2\" data-v-08751f2b></rect><path d=\"M7 11V7a5 5 0 0110 0v4\" data-v-08751f2b></path></svg><span class=\"text-[12px] text-[#8e8e93]\" data-v-08751f2b>yoursite.com</span></div></div>", 2)
const _hoisted_19 = { class: "phone-content" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"safari-toolbar\" data-v-08751f2b><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#007AFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-08751f2b><polyline points=\"15 18 9 12 15 6\" data-v-08751f2b></polyline></svg><svg width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#007AFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-08751f2b><polyline points=\"9 18 15 12 9 6\" data-v-08751f2b></polyline></svg><svg width=\"19\" height=\"19\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#007AFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-08751f2b><path d=\"M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8\" data-v-08751f2b></path><polyline points=\"16 6 12 2 8 6\" data-v-08751f2b></polyline><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"15\" data-v-08751f2b></line></svg><svg width=\"19\" height=\"19\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#007AFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-08751f2b><path d=\"M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z\" data-v-08751f2b></path></svg><svg width=\"19\" height=\"19\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#007AFF\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-08751f2b><rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\" data-v-08751f2b></rect><rect x=\"7\" y=\"7\" width=\"14\" height=\"14\" rx=\"2\" ry=\"2\" data-v-08751f2b></rect></svg></div><div class=\"safari-home-indicator\" data-v-08751f2b><div class=\"safari-home-indicator-bar\" data-v-08751f2b></div></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationPopup = _resolveComponent("NotificationPopup")!
  const _component_CopyIcon = _resolveComponent("CopyIcon")!
  const _component_WidgetCompiled = _resolveComponent("WidgetCompiled")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (this.widget.edited)
      ? (_openBlock(), _createBlock(_component_NotificationPopup, {
          key: 0,
          status: "warning",
          title: "Changes Unpublished",
          text: "To view your updates on the widget, please save and publish them.",
          class: "mb-6"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.changeCase('additional', _ctx.ElementE.TITLE)), 1),
      _createElementVNode("div", _hoisted_4, [
        (!this.widget.edited)
          ? (_openBlock(), _createBlock(_component_NotificationPopup, {
              key: 0,
              status: "info",
              title: "Your widget is ready for publication!",
              text: "Copy and paste the embed code into your secure website to display the widget."
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.changeCase('embed code', _ctx.ElementE.LABEL)) + " ", 1),
              _createVNode(_component_CopyIcon, {
                onClick: _ctx.copyEmbedCode,
                class: "cursor-pointer hover:opacity-80"
              }, null, 8, ["onClick"])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args))),
              ref: "textarea",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.embedCode) = $event)),
              id: "embed-code",
              class: "input-primary",
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.embedCode]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString(_ctx.changeCase('preview', _ctx.ElementE.TITLE)), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.previewMode = 'desktop')),
            class: _normalizeClass([
              'flex items-center gap-1.5 px-3 py-1 text-xs font-medium transition-colors',
              _ctx.previewMode === 'desktop'
                ? 'bg-neutral-100 text-white'
                : 'bg-white text-neutral-75 hover:bg-neutral-0'
            ])
          }, [
            _hoisted_11,
            _createTextVNode(" Desktop ")
          ], 2),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.previewMode = 'mobile')),
            class: _normalizeClass([
              'flex items-center gap-1.5 px-3 py-1 text-xs font-medium transition-colors',
              _ctx.previewMode === 'mobile'
                ? 'bg-neutral-100 text-white'
                : 'bg-white text-neutral-75 hover:bg-neutral-0'
            ])
          }, [
            _hoisted_12,
            _createTextVNode(" Mobile ")
          ], 2)
        ])
      ]),
      (_ctx.previewMode === 'desktop')
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_WidgetCompiled, {
                api: _ctx.api,
                "widget-id": _ctx.widgets.id
              }, null, 8, ["api", "widget-id"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_WidgetCompiled, {
                  api: _ctx.api,
                  "widget-id": _ctx.widgets.id
                }, null, 8, ["api", "widget-id"])
              ]),
              _hoisted_20
            ])
          ]))
    ])
  ]))
}